import { PerformanceAnalysisChartType } from '@/constants/performance';

export default {
  CLIENT: {
    id: 'CLIENT',
    mainChart: {
      name: '접속자',
      rscInfoList: [
        {
          rsctypeId: 'WIRELESS_CONTROLLER',
          rscId: 'CLIENT_COUNT',
          rscKey: '_',
        },
      ],
    },
    subCharts: [
      {
        id: 'SSID_CLIENT',
        name: 'SSID별 접속자',
        rscInfoList: [
          {
            rsctypeId: 'WIRELESS_CONTROLLER',
            rscId: 'SSID_CLIENT_COUNT',
          },
        ],
      },
      {
        id: 'RADIOBAND_CLIENT',
        name: '주파수 대역별 접속자',
        rscInfoList: [
          {
            rsctypeId: 'WIRELESS_CONTROLLER',
            rscId: 'RADIOBAND_CLIENT_COUNT',
          },
        ],
      },
      {
        id: 'CHANNEL_CLIENT',
        name: '채널별 접속자',
        rscInfoList: [
          {
            rsctypeId: 'WIRELESS_CONTROLLER',
            rscId: 'CHANNEL_CLIENT_COUNT',
          },
        ],
      },
      {
        id: 'APGROUP_CLIENT',
        name: 'AP 그룹별 접속자',
        rscInfoList: [
          {
            rsctypeId: 'WIRELESS_CONTROLLER',
            rscId: 'APGROUP_CLIENT_COUNT',
          },
        ],
      },
    ],
  },
  SSID_TRAFFIC: {
    id: 'SSID_TRAFFIC',
    chartType: PerformanceAnalysisChartType.MULTI_RSC_KEY,
    mainChart: {
      name: 'SSID별 트래픽',
      rscInfoList: [
        {
          rsctypeId: 'WIRELESS_CONTROLLER',
          rscId: 'SSID_TRAFFIC_BPS_IN',
        },
      ],
    },
    subCharts: [
      {
        id: 'SSID_TRAFFIC',
        name: 'SSID별 트래픽',
        rscInfoList: [
          {
            rsctypeId: 'WIRELESS_CONTROLLER',
            rscId: 'SSID_TRAFFIC_BPS_OUT',
          },
        ],
      },
    ],
  },
  RADIOBAND_TRAFFIC: {
    id: 'RADIOBAND_TRAFFIC',
    chartType: PerformanceAnalysisChartType.MULTI_RSC_KEY,
    mainChart: {
      name: '주파수 대역별 트래픽',
      rscInfoList: [
        {
          rsctypeId: 'WIRELESS_CONTROLLER',
          rscId: 'RADIOBAND_TRAFFIC_BPS_IN',
        },
      ],
    },
    subCharts: [
      {
        id: 'RADIOBAND_TRAFFIC',
        name: '주파수 대역별 트래픽',
        rscInfoList: [
          {
            rsctypeId: 'WIRELESS_CONTROLLER',
            rscId: 'RADIOBAND_TRAFFIC_BPS_OUT',
          },
        ],
      },
    ],
  },
  CHANNEL_TRAFFIC: {
    id: 'CHANNEL_TRAFFIC',
    chartType: PerformanceAnalysisChartType.MULTI_RSC_KEY,
    mainChart: {
      name: '채널별 트래픽',
      rscInfoList: [
        {
          rsctypeId: 'WIRELESS_CONTROLLER',
          rscId: 'CHANNEL_TRAFFIC_BPS_IN',
        },
      ],
    },
    subCharts: [
      {
        id: 'CHANNEL_TRAFFIC',
        name: '채널별 트래픽',
        rscInfoList: [
          {
            rsctypeId: 'WIRELESS_CONTROLLER',
            rscId: 'CHANNEL_TRAFFIC_BPS_OUT',
          },
        ],
      },
    ],
  },
  AP_GROUP_TRAFFIC: {
    id: 'AP_GROUP_TRAFFIC',
    chartType: PerformanceAnalysisChartType.MULTI_RSC_KEY,
    mainChart: {
      name: 'AP 그룹별 트래픽',
      rscInfoList: [
        {
          rsctypeId: 'WIRELESS_CONTROLLER',
          rscId: 'APGROUP_TRAFFIC_BPS_IN',
        },
      ],
    },
    subCharts: [
      {
        id: 'AP_GROUP_TRAFFIC',
        name: 'AP 그룹별 트래픽',
        rscInfoList: [
          {
            rsctypeId: 'WIRELESS_CONTROLLER',
            rscId: 'APGROUP_TRAFFIC_BPS_OUT',
          },
        ],
      },
    ],
  },
  ROGUE_AP: {
    id: 'ROGUE_AP',
    mainChart: {
      name: '비인가 AP',
      rscInfoList: [
        {
          rsctypeId: 'WIRELESS_CONTROLLER',
          rscId: 'ROGUE_AP_COUNT',
          rscKey: '_',
        },
      ],
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/performance/node/analysis/ap-controller/perf-chart-type.js